<div class="content">
  <h3>Edit Roles for {{ data.userId }}</h3>
  <div [formGroup]="form">
    <kion-select
            [options]="basestores$ | async"
            id="select-basestore"
            controlName="baseStore"
            [form]="form"
            [disablePlaceHolder]="true
        ">
    </kion-select>
    <div class="roles">
      <div *ngFor="let role of roles" class="role">
        <label>
          <input type="checkbox" placeholder="{{ role.name }}" (click)="role.isSelected ? revokeRole(role.id) : setRole(role.id)"  value="{{ role.name }}" [checked]="role.isSelected"/>
          {{ role.name }}
        </label>
      </div>
    </div>
  </div>
</div>
